export enum RegionEndpoints {
  FetchRegions = '/regions',
}